import { useEffect, useMemo, useState } from "react";
import BaseModal, { FRONTEND_URL } from "./BaseModal";
import styles from "./BaseModal.module.css";
import { authClient } from "../../lib/auth-client";

let openSignUpModalRef: (() => void) | null = null;

export function showSignUpModal() {
  openSignUpModalRef?.();
}

export default function SignUpModal() {
  const [open, setOpen] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const canSubmit = useMemo(() => {
    return (
      !!name.trim() &&
      !!email.trim() &&
      !!password &&
      !!confirmPassword &&
      password === confirmPassword
    );
  }, [name, email, password, confirmPassword]);

  useEffect(() => {
    openSignUpModalRef = () => {
      setErrorMsg("");
      setOpen(true);
    };

    return () => {
      openSignUpModalRef = null;
    };
  }, []);

  function closeModal() {
    setOpen(false);
    setLoading(false);
    setErrorMsg("");
    setConfirmPassword("");
  }

  async function handleSave() {
    if (password !== confirmPassword) {
      setErrorMsg("As senhas não conferem.");
      return;
    }

    setLoading(true);
    setErrorMsg("");
    
    await authClient.signUp.email(
      {
        name,
        email,
        password,
        callbackURL: FRONTEND_URL,  // Importante!!! URL to redirect to after the user verifies their email
      },
      {
        onSuccess: () => {
          alert('Usuário adicionado com sucesso\nPlease verify your email address')
          closeModal();
        },
        onError: (ctx) => {
          setErrorMsg(ctx.error.message || "Erro ao criar conta.");
          setLoading(false);
        },
      }
    );
  }

  return (
    <BaseModal
      open={open}
      title="Sign up"
      subtitle="Crie sua conta"
      onCancel={closeModal}
    >
      <div className={styles.body}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Nome</label>
          <input
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Seu nome"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Email</label>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@email.com"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Senha</label>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="mínimo 8 caracteres"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Confirmar senha</label>
          <input
            type="password"
            className={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="repita a senha"
          />
        </div>

        {errorMsg ? (
          <p className={styles.errorMessage}>{errorMsg}</p>
        ) : null}

        <div className={styles.actions}>
          <button
            type="button"
            onClick={closeModal}
            className={`${styles.button} ${styles.buttonSecondary}`}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSave}
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading || !canSubmit}
          >
            {loading ? "Criando..." : "Save"}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
